export const sleepMs = (milliseconds: number) => {
  let timeoutId: number;
  return new Promise(resolve => {
    timeoutId = window.setTimeout(resolve, milliseconds);
  }).finally(() => clearTimeout(timeoutId));
};
